import { put, takeLatest } from "redux-saga/effects";
import { VanActionCreators } from "src/store/reducers/van/action-creators";
import { VanActionEnum } from "src/store/reducers/van/types";
import instance from "../set";

function* fetchGetVan({
  id,
}: ReturnType<typeof VanActionCreators.getVan>) {
  try {
    const { data } = yield instance.get(`van/${id}`);
    yield put(VanActionCreators.resultGetVan(data));
  } catch (error) {
    console.log("error :>> ", error);
  }
}
export function* actionWatcherGetVan() {
  yield takeLatest(VanActionEnum.REQUEST_VAN, fetchGetVan);
}
